import React from 'react';

import { makeStyles } from 'tss-react/mui';

import type { MarkdownComponentProps } from '../ChatPanelMarkdown';

const useStyles = makeStyles()(theme => ({
  blockquote: {
    borderLeft: `${theme.typography.pxToRem(4)} solid ${theme.palette.divider}`,
    marginLeft: 0,
    marginRight: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
  },
}));

export const BlockquoteElement = React.memo(function BlockquoteElement(
  props: MarkdownComponentProps<HTMLQuoteElement>
) {
  const { classes } = useStyles();
  return <blockquote {...props} className={classes.blockquote} />;
});
